export default {
  'templates.tpl_vars_set_placeholder': 'Zestaw zmiennych',
  'templates.tpl_type_placeholder': 'Typ szablonu',
  'templates.tokens': 'Zmienne',
  'templates.tpl_vars_set': 'Zestaw zmiennych',
  'templates.tpl_type': 'Typ szablonu',
  'templates.required_variables': 'Wymagane zmienne',
  'templates.to_create_template': 'Aby stworzyć szablon przejdź tutaj',
  'templates.set_as_default_template': 'Ustaw jako domyślny szablon',
  'templates.this_required': 'Te pole jest wymagane',
  'templates.mjml_tooltip': 'Wklej szablon mjml',
  'templates.is_default': 'Jest domyślny',
  'code.snippet': 'Spróbuj wprowadzić @ dla autocomplete',
};
